import { inject, Injectable } from '@angular/core';
import { catchError, map, of, switchMap } from 'rxjs';
import { UserActions } from '../actions/index';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { UserEffectService } from './users.effects.service';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()

export class UsersEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions: Actions,
    private apiService: ApiService,
    private globalService: GlobalService,
    private userEffectService: UserEffectService
  ) { }

  FetchUsers$ = createEffect(() =>
    this.actions.pipe(
      ofType(UserActions.loadUsersTableData),
      switchMap((action) => this.apiService.usersDetails(action)),
      map((data) => {
        const b2bCustomers = this.userEffectService.formatUsersData(data?.b2bCustomers);
        this.globalService.loadingSubject.next(false);
        return UserActions.loadUsersTableDataSuccess({ b2bCustomers });
      }),
      catchError((error) =>
        of(UserActions.loadUsersTableDataFail({ payload: tryNormalizeHttpError(error, this.logger) }))
      )
    )
  );
}
